import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { postVoipCall } from 'queries';
import { parseErrors, Toast } from 'helpers';

export function useAiAssistantActions() {
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [ticketTitle, setTicketTitle] = useState('');

  const { mutate: startCall } = useMutation(postVoipCall, {
    onError: (error: any) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const handleCreateTicket = (title?: string) => {
    if (title) {
      setTicketTitle(title);
    }
    setIsTicketModalOpen(true);
  };

  const handleCallCustomer = (phone?: string) => {
    if (phone) {
      const numberToCall = phone.replace(/\s/g, '');
      startCall(numberToCall);
    }
  };

  return {
    isTicketModalOpen,
    setIsTicketModalOpen,
    ticketTitle,
    handleCreateTicket,
    handleCallCustomer,
  };
}
